import { isAxiosError } from 'axios'

/** A rejected request — the API refused the identifier before it reached the database. */
const BAD_REQUEST = 400
const NOT_FOUND = 404

/**
 * Whether a failed detail read failed because its identifier names no record.
 *
 * Detail pages must tell "this record is absent" apart from "the request failed": the
 * first is a dead end the user should be told about plainly, the second is worth
 * retrying. react-query reports both as `isError`, so the status has to be inspected.
 *
 * A malformed identifier counts as absent. The API validates a uuid path parameter before
 * touching the database and answers 400, and a route value that cannot name a record is
 * the same dead end as one that names a missing one — surfacing it as a retryable failure
 * would invite the user to retry a URL that can never resolve. A read carries no body, so
 * a 400 on one cannot mean anything else.
 */
export const isNotFound = (error: unknown): boolean =>
	isAxiosError(error) && (error.response?.status === NOT_FOUND || error.response?.status === BAD_REQUEST)
